import { GlobalOutlined } from '@ant-design/icons';
import { useLocalStorageState } from 'ahooks';
import { Dropdown, MenuProps } from 'antd';
import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { languageMap } from '@/utils';

import styles from './index.module.less';
import { LanguageCode } from '@/types/enum';

const GlobalLan: FC = () => {
  const { i18n } = useTranslation();
  const changeHandle = useCallback(
    (lan: string) => {
      i18n.changeLanguage(lan);
    },
    [i18n]
  );

  const languageMenuItems = useMemo<MenuProps['items']>(
    () =>
      Object.keys(languageMap).map((key) => ({
        label: (languageMap as any)[key].name,
        key,
        onClick: () => changeHandle(key),
      })),
    [changeHandle]
  );

  return (
    <Dropdown menu={{ items: languageMenuItems }} placement="bottom">
      <div className={styles['language-selecter']}>
        <GlobalOutlined style={{ color: 'black', fontSize: 18, display: 'block' }} />
        <span className={styles.name}>
          {(languageMap as any)[i18n.language || LanguageCode.ZhCn]?.name || i18n.language}
        </span>
      </div>
    </Dropdown>
  );
};

export default GlobalLan;
